import { Injectable } from '@angular/core';
import { fromPromise } from '@apollo/client/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable, of } from 'rxjs';
import { EmployeesData } from '../data/employees-data'

@Injectable()
export class EmployeesService extends EmployeesData
{
    allEmployees: CompanyEmployeeWithSubsidyAmount[] = [
        {
            id: 1,
            totalAmount: 200,
            code: 'abc',
            name: 'John',
            surname: 'Doe',
            email: 'john@doe.eu',
            lastOrderDate: '',
            lastOrderValue: 0,
            subsidizedAmount: 0,
            isDeactivated: false,
            remainingSubsidy: 0,
            canMakeOrderFrom: null,
            canMakeOrderTo: null
        },
        {
            id: 2,
            totalAmount: 150,
            code: 'def',
            name: 'Debra',
            surname: 'Allen',
            email: 'debra@allen.com',
            lastOrderDate: '',
            lastOrderValue: 0,
            subsidizedAmount: 0,
            isDeactivated: false,
            remainingSubsidy: 0,
            canMakeOrderFrom: null,
            canMakeOrderTo: null
        },
        {
            id: 3,
            totalAmount: 350,
            code: 'def',
            name: 'Jack',
            surname: 'Sparrow',
            email: 'jack@sparrow.net',
            lastOrderDate: '',
            lastOrderValue: 0,
            subsidizedAmount: 0,
            isDeactivated: false,
            remainingSubsidy: 0,
            canMakeOrderFrom: null,
            canMakeOrderTo: null
        },
        {
            id: 4,
            totalAmount: 0,
            code: 'def',
            name: 'Frank',
            surname: 'Drebin',
            email: 'frank@drebin.com',
            employeeGroup: {
                id: 1,
                name: 'test'
            },
            lastOrderDate: '',
            lastOrderValue: 0,
            subsidizedAmount: 0,
            isDeactivated: false,
            remainingSubsidy: 0,
            canMakeOrderFrom: null,
            canMakeOrderTo: null
        }
    ];

    getNoOrdersEmployeesTableData(): Observable<CompanyEmployeeWithSubsidyAmount[]>{
        return of(this.allEmployees.filter(a => a.totalAmount > 10));
    }

    getAllEmployeesTableData(): Observable<CompanyEmployeeWithSubsidyAmount[]>{
        return of(this.allEmployees);
    }

    
}